import React from 'react';
import { useSelector } from 'react-redux';

import type { Template } from 'js/src/client';
import TemplateCategoryPreview from 'js/src/components/app/template-preview/TemplateCategoryPreview';
import { getTemplateCategoryIds } from 'js/src/data/templates';
import type { ImmutableMap, TemplateCategoryId } from 'js/src/libs/consts';
import type { RootState } from 'js/src/libs/RootState';

type TemplateCategoryPreviewListProps = {
    getTemplateCategoryRefs?: () => Map<TemplateCategoryId, HTMLElement>;
    onTemplateClick: (template: ImmutableMap<Template>) => void;
    selectedTemplateId?: string;
    hidePreviewButton?: boolean;
};

const TemplateCategoryPreviewList = React.memo(function TemplateCategoryPreviewList({
    onTemplateClick,
    getTemplateCategoryRefs,
    selectedTemplateId,
    hidePreviewButton,
}: TemplateCategoryPreviewListProps) {
    const categoryIds = useSelector((state: RootState) => getTemplateCategoryIds(state));

    return (
        <>
            {categoryIds.map((categoryId) => (
                <TemplateCategoryPreview
                    key={categoryId}
                    categoryId={categoryId}
                    onTemplateClick={onTemplateClick}
                    getTemplateCategoryRefs={getTemplateCategoryRefs}
                    selectedTemplateId={selectedTemplateId}
                    hidePreviewButton={hidePreviewButton}
                />
            ))}
        </>
    );
});

export default TemplateCategoryPreviewList;
